module.exports = "/static-assets/_next/static/images/frame-mask-2c4fe24a9a6aaa55c9765a43be222b6d.png";